import React, { useState } from "react";
import LogoCelucambio from "../../img/LogoCelucambio"; 
import LogoQuieromac from "../../img/LogoQuieromac"; 
import Button from "../Button/Button";
import Close from "../../img/Close";
import PopUp from "../PopUp/PopUp";
import styles from "./styles.css";

function Header({ brand, model, storage, goodCondition, buttonsCondition, exteriorCondition, screenCondition, grade, price, sendInfoData }) {
  const [isClosed, setIsClosed] = useState(false);

  const currentURL = window.location.href;
  const isCelucambio = currentURL.includes('celucambio');
  const isQuieromac = currentURL.includes('quieromac');
  const redirectUrl = window.redirectUrl;

  const handleCloseClick = () => {
    setIsClosed(true);
    window.location.href = redirectUrl;
  };

  const handlePopUpClose = () => {
    setIsClosed(false); 
  };

  return (
    <div>
      <header className={isClosed ? "header closed" : "header"}>
        {isCelucambio && (
          <LogoCelucambio onClick={() => { window.location.assign(redirectUrl); }} />
        )}
        {isQuieromac && (
          <LogoQuieromac onClick={() => { window.location.assign(redirectUrl); }} />
        )}
        <Button
          color="white"
          onClick={handleCloseClick}
        >
          <Close color={isClosed ? "white" : "black"} />
        </Button>
      </header>
      {/* {isClosed && (
        <PopUp
          type="toClose"
          onClose={handlePopUpClose}
          brand={brand}
          model={model}
          storage={storage}
          goodCondition={goodCondition}
          buttonsCondition={buttonsCondition}
          exteriorCondition={exteriorCondition}
          screenCondition={screenCondition}
          grade={grade}
          price={price}
          sendInfoData={sendInfoData}
        />
      )} */}
    </div>
  );
}

export default Header;
